export default __webpack_public_path__ + "static/step_03-05b99213209d2ce0daec96c0bf33fedf.png";